var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4446 15.3334C13.4446 14.8619 13.2573 14.4098 12.9239 14.0764C12.5905 13.743 12.1383 13.5557 11.6668 13.5557H6.33344C5.86195 13.5557 5.40976 13.743 5.07636 14.0764C4.74297 14.4098 4.55566 14.8619 4.55566 15.3334",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2222 2.88867H2.77778C1.79594 2.88867 1 3.68461 1 4.66645V17.1109C1 18.0927 1.79594 18.8887 2.77778 18.8887H15.2222C16.2041 18.8887 17 18.0927 17 17.1109V4.66645C17 3.68461 16.2041 2.88867 15.2222 2.88867Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99995 9.99989C9.98179 9.99989 10.7777 9.20395 10.7777 8.22211C10.7777 7.24027 9.98179 6.44434 8.99995 6.44434C8.01811 6.44434 7.22217 7.24027 7.22217 8.22211C7.22217 9.20395 8.01811 9.99989 8.99995 9.99989Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44434 1.11133V2.88911",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5557 1.11133V2.88911",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id_card.b4cd5fa0b95f8dadc8cb7a4a2b57d290.svg";
export { ForwardRef as ReactComponent };